import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { PageHeader } from "../../components/Layout";

export default function ResultsList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/attempts").then((r) => setItems(r.data.filter((a) => a.status === "submitted"))).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader overline="History" title="All my results" />
      {loading ? <div className="text-sm text-zinc-500">Loading…</div> :
        items.length === 0 ? <div className="border border-zinc-200 p-10 text-center text-sm text-zinc-500">No completed exams yet.</div> :
          <div className="border border-zinc-200" data-testid="results-list">
            {items.map((a, i) => (
              <Link key={a.attempt_id} to={`/app/results/${a.attempt_id}`} className={`flex items-center justify-between p-5 hover:bg-zinc-50 ${i < items.length - 1 ? "border-b border-zinc-200" : ""}`}>
                <div>
                  <div className="font-medium">{a.exam_title}</div>
                  <div className="text-xs text-zinc-500 mt-1">{new Date(a.submitted_at).toLocaleString()}</div>
                </div>
                <div className="flex items-center gap-6">
                  <div className="text-right">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Score</div>
                    <div className="font-mono-tab text-lg font-bold">{a.score} / {a.total_marks}</div>
                  </div>
                  <div className={`text-[10px] uppercase tracking-[0.2em] font-semibold border px-2 py-1 ${a.result?.passed ? "border-green-600 text-green-700 bg-green-50" : "border-red-600 text-red-700 bg-red-50"}`}>
                    {a.result?.passed ? "Pass" : "Fail"}
                  </div>
                </div>
              </Link>
            ))}
          </div>
      }
    </div>
  );
}
